import { AboutUs } from "@/lib/interfaces/embed";

const splitParagraphs = (text: string) =>
  text
    .split("\n")
    .map((p) => p.trim())
    .filter(Boolean);

export function JobPostsV2AboutUs({
  organizationName,
  aboutUs,
}: {
  organizationName: string;
  aboutUs?: AboutUs;
}) {
  if (!aboutUs) return null;

  const paragraphs = splitParagraphs(aboutUs.description);
  const hasImage = Boolean(aboutUs.imageUrl);

  if (!hasImage) {
    return (
      <div className="max-w-2xl mx-auto text-center">
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900">Über {organizationName}</h2>
        <div className="mt-6 space-y-4 text-sm md:text-base text-gray-600 leading-relaxed">
          {paragraphs.length > 0 ? paragraphs.map((p, i) => <p key={i}>{p}</p>) : <p>{aboutUs.description}</p>}
        </div>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-center">
      <div>
        <h2 className="text-2xl md:text-3xl font-bold tracking-tight text-gray-900">Über {organizationName}</h2>
        <div className="mt-6 space-y-4 text-sm md:text-base text-gray-600 leading-relaxed">
          {paragraphs.length > 0 ? paragraphs.map((p, i) => <p key={i}>{p}</p>) : <p>{aboutUs.description}</p>}
        </div>
      </div>

      <div className="w-full">
        <div className="relative overflow-hidden rounded-2xl bg-gray-200 shadow-sm">
          <img src={aboutUs.imageUrl} alt="" className="h-[280px] md:h-[320px] w-full object-cover" />
        </div>
      </div>
    </div>
  );
}

